import Regra from "./Regra";

class UsuarioAuth {
  "id": number = 0;
  "userName": string = "";
  "passwordHash": string = "";
  "email": string = "";
  "token": string = "";
  "ultimoAcesso": Date = new Date();
  "autenticado": boolean = false;
  "brf": boolean = false;
  "recaptchaToken"?: string = "";
  //"regra" : Regra[] = [];
}
export default UsuarioAuth;
